import { ICronJob } from '../../models/ICronJob';
import { api } from './api';
import { IServerResponse, UpdateCronJobActiveRequest } from './types';

export const cronJobsApi = api.injectEndpoints({
    endpoints: (build) => ({
        getAllCronJobs: build.query<ICronJob[], void>({
            query: () => ({ url: '/cron-jobs/get-all' }),
            providesTags: ['CronJob'],
        }),
        updateCronJobActive: build.mutation<IServerResponse, UpdateCronJobActiveRequest>({
            query: (body: UpdateCronJobActiveRequest) => ({
                url: '/cron-jobs/update-active',
                method: 'POST',
                body,
                credentials: 'include',
            }),
            invalidatesTags: (result, error) => error ? [] : ['CronJob'],
        }),
    })
})

export const {
    useGetAllCronJobsQuery,
    useUpdateCronJobActiveMutation,
} = cronJobsApi
